import React, { useContext } from 'react';
import { FaBookmark } from 'react-icons/fa';

import { Container, Titulo, ButtonsContainer, ButtonAtalho, Label } from './styles';

import { useLocation, useNavigate } from 'react-router-dom';
import useRotaBase from '../../utils/useRotaBase';
import IconeDinamico from '../IconeDinamico';
import Context, { IContext } from '../../context/Context';

export default function MenuAtalhos() {
  const rotaBase = useRotaBase();
  const navigate = useNavigate();
  const location = useLocation();
  const { atalhos }: IContext = useContext(Context);

  return (
    <Container aria-label='Atalhos rápidos'>
      <Titulo><FaBookmark /> Atalhos rápidos</Titulo>
      <ButtonsContainer>
        {(atalhos && atalhos?.filhos) && atalhos.filhos.map((item, index) => (
          <ButtonAtalho
            key={index}
            type='button'
            $ativo={!!item?.rot && location.pathname === `${rotaBase}${item.rot}`}
            onClick={() => {
              if (item?.rot) {
                navigate(`${rotaBase}${item.rot}`);
              }
            }}
          >
            <IconeDinamico nome={item?.nomico || 'FaBookmark'} size={16} />
            <Label title={item.mensis}>{item.mensis}</Label>
          </ButtonAtalho>
        ))}
      </ButtonsContainer>
    </Container>
  );
}
